export default import.meta.ROLLUP_FILE_URL_qqJRVEh6aGlxhf56pSYIBA;